import React from "react";

export default function BlueNotificationBanner() {
  return (
    <div className="w-full bg-[#1A73E8] text-white py-3.5 px-4 text-center font-oswald text-xs sm:text-sm md:text-base font-bold tracking-wider select-none relative z-10">
      BAB MEDIA NEWS AND EXCLUSIVE CONTENT REMAIN EXCLUSIVE TO THEIR OWN DEDICATED TABS.
    </div>
  );
}
